import React, { useCallback } from 'react'
import { Checkbox } from '@chakra-ui/react'

export const BooleanCheckbox = React.forwardRef(
  ({ value = '', defaultValue = false, onChange, isLoading, ...props }, ref) => {
    const handleChange = useCallback(e => onChange?.(e.target.checked), [onChange])
    return (
      <Checkbox
        {...props}
        isChecked={value}
        defaultChecked={defaultValue}
        onChange={handleChange}
        ref={ref}
      />
    )
  }
)

export default BooleanCheckbox
